import toastr from "toastr";

toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: "toast-bottom-full-width",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut"
};

const memo = {
    cancelVisitInquiryResultSuccess: 1,
    cancelVisitInquiryResultVisitDatetimeExpired: 2,
    toggleItem: function (target) {
        $(target).next().slideToggle();
        $(target).toggleClass("open");
    },
    handleCancelVisitInquiryDone: function ({ result, message }, paramList) {
        const govHokatsuKibanVisitInquiryId = paramList.get("govHokatsuKibanVisitInquiryId");
        if (result === memo.cancelVisitInquiryResultSuccess) {
            $(`[data-gov-hokatsu-kiban-visit-inquiry-id=${govHokatsuKibanVisitInquiryId}]`).hide();
            $(`#js-request-status-${govHokatsuKibanVisitInquiryId}`).text("予約キャンセル");
            toastr.success(message);
            return;
        }

        if (result === memo.cancelVisitInquiryResultVisitDatetimeExpired) {
            $(`[data-gov-hokatsu-kiban-visit-inquiry-id=${govHokatsuKibanVisitInquiryId}]`).hide();
        }
        toastr.error(message);
    },
    handleCancelVisitInquiryFail: function (jqXHR) {
        if (jqXHR["status"] === 403) {
            // 自分以外の見学予約をキャンセルしたとき
            toastr.error("エラーが発生しました。しばらくお待ち下さい");
            return;
        }

        if (jqXHR["status"] === 422) {
            toastr.error(jqXHR["responseJSON"]["message"]);
        }
    },
    cancelVisitInquiry: function (govHokatsuKibanVisitInquiryId) {
        const paramList = new FormData();
        paramList.append("govHokatsuKibanVisitInquiryId", govHokatsuKibanVisitInquiryId);

        post.postAjaxData(
            "/parent/govHokatsuKibanVisitInquiry/cancel",
            paramList,
            "",
            memo.handleCancelVisitInquiryDone,
            memo.handleCancelVisitInquiryFail,
            null
        );
    }
};
window.memo = memo;

$(document).ready(function (e) {
    if ($(".js-memo-page").length === 0) {
        return;
    }

    //評価のラジオボタンで、選択済みの要素がクリックされたとき解除する
    let reviewType = $('input[name="reviewType"]:checked').val() || "";
    $('input[name="reviewType"]').on("click", function () {
        if ($(this).val() === reviewType) {
            $(this).prop("checked", false);
            reviewType = "";
        } else {
            reviewType = $(this).val();
        }
    });

    // トグルボタンを押したとき
    $(".nursery-memo--toggle").on("click", function () {
        pageDetail.toggleItem(this);
    });

    $(".js-cancel-inquiry-visit-button").click(function () {
        $("#js-modal-delete .button-small--yes").data(
            "govHokatsuKibanVisitInquiryId",
            $(this).data("govHokatsuKibanVisitInquiryId")
        );
        modalWindow.showModal("#js-modal-delete");
    });
    $("#js-modal-delete .button-small--yes").click(function () {
        memo.cancelVisitInquiry($(this).data("govHokatsuKibanVisitInquiryId"));
    });
});
